
import { useCallback } from 'react';
import { distributionDataTypeToString, distributionDataTypeToUnit } from '../models/distribution-data-type-to-string';
import { DistributionDataType } from '../models/map-attribute';
import { useStore } from 'react-admin';

export const useDataType = (): [DistributionDataType, (value?: number) => string, () => string] => {
  const [dataType] = useStore<DistributionDataType>('map.mapAttribute.dataType', 'number');

  const getDataTypeString = useCallback((value?: number) => distributionDataTypeToString(value, dataType), [dataType]);
  const getDataTypeUnit = useCallback(() => distributionDataTypeToUnit(dataType), [dataType]);

  return [dataType, getDataTypeString, getDataTypeUnit];
}
